import Boto from '../Boto/Boto';
import styles from './modulVerifica.module.scss';
import Icona from '../../../components/3catinfo/ui/Icona';

const ModulVerifica = (props) => {
    const { titol, text, textBoto, linkBoto } = props;

    return (
        <div className={styles.modulVerifica}>
            <Icona inline={true} className={styles.icona} icona={'info_verifica'} ariaHidden={true} />
            <div className={styles.content}>
                <h2 className={styles.titol}>{titol}</h2>
                <p className={styles.text}>{text}</p>
                <Boto text={textBoto} link={linkBoto} />
            </div>
        </div>
    );
};

export default ModulVerifica;
